'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: ', ';\n  z-index: 1000;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  height: 56px;\n  right: 0px;\n  left: ', ';\n  transition: left 0.5s;\n  display: flex;\n  align-items: center;\n  padding: 0 20px 0 20px;\n  @media print {\n    display: none;\n  }\n'], ['\n  position: ', ';\n  z-index: 1000;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  height: 56px;\n  right: 0px;\n  left: ', ';\n  transition: left 0.5s;\n  display: flex;\n  align-items: center;\n  padding: 0 20px 0 20px;\n  @media print {\n    display: none;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledHeaderContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.fixed ? 'fixed' : 'static';
}, function (props) {
  return props.open ? props.sidebarWidth : '0px';
});

StyledHeaderContainer.displayName = 'StyledHeaderContainer';

exports.default = StyledHeaderContainer;
//# sourceMappingURL=StyledHeaderContainer.js.map


//////////////////
// WEBPACK FOOTER
// ../app-layout/lib/components/AppHeader/StyledHeaderContainer.js
// module id = 121
// module chunks = 0